
    /**
     * split a MAC address like '0c2a69001338'
     *      into something like '0c:2a:69:00:13:38'
     */
    function format_mac_address(address) {
        var octets = address.match(/.{1,2}/g);
        if (octets) return octets.join(':');
    }
    export default format_mac_address;

